/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { Box } from '@mui/material'
import React from 'react'

type StickyHeaderProps = {
  children?: React.ReactNode
  zIndex?: number
  paddingTop?: number
  backgroundColor?: string
}

const StickyHeader: React.FC<StickyHeaderProps> = ({
  children,
  zIndex = 1100,
  paddingTop = 1,
  backgroundColor,
}) => {
  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex,
        backgroundColor:
          backgroundColor || (theme => theme.palette.background.default),
        paddingTop,
        width: '100%',
      }}
    >
      {children}
    </Box>
  )
}

export default StickyHeader
